import { FetchData, MediaState } from '../cloneme-classes';
import { UserManager } from '../cloneme-classes';
import { getCurrentDomainFolder } from '../utils';

type Plan = {
  id: number;
  uuid: string | null;
  price: number;
};

type SubscriptionPlan = {
  id: number;
  premium_creator: Plan;
  premium: Plan;
  essentials: Plan;
  starter: Plan;
};

type SubscriptionData = {
  id: number;
  yearly: SubscriptionPlan;
  biannually: SubscriptionPlan;
  monthly: SubscriptionPlan;
};

function toFixedIfNecessary(value: number, dp: number) {
  return value.toFixed(dp);
}

const VISIBLE_TIERS = ['starter'] as const;
const VISIBLE_DURATIONS = ['monthly'] as const;

export class PricingEcSuitePage {
  private userManager: UserManager | undefined;
  private productPricesById?: SubscriptionData;

  public async init(): Promise<void> {
    this.userManager = await UserManager.getInstance();
    this.productPricesById = await FetchData.getSubscriptions();

    if (this.userManager.status == UserManager.AUTH_STATUS__LOGGED_OUT) {
      if (document.querySelector('.pricing-col-starter .logged-out')) {
        // @ts-ignore
        document.querySelector('.pricing-col-starter .logged-out').style.display = 'block';
      }

      if (document.querySelector('.pricing-col-starter .pricing-content-pricing')) {
        // @ts-ignore
        document.querySelector('.pricing-col-starter .pricing-content-pricing').style.display =
          'none';
      }
    }

    const durationRadioGroupInputs = document.querySelectorAll('input[name=duration-radio-group]');

    const durationRadioGroupInputsArray = Array.from(durationRadioGroupInputs);

    const selectedValueArray = durationRadioGroupInputsArray.filter(
      (inputRadioButton: any) => inputRadioButton.checked
    );

    this.setDurationRadio();
    this.initProductButtons();
    this.initEvents();
    this.setupLoginButtons();
  }

  initEvents(): void {
    window.addEventListener("ecsuite:payment-success", (e) => {
      console.log("Payment success:", e.detail);
      window.location.href = document.referrer;
    });
  }

  setupLoginButtons() {
    const loginButtons = document.querySelectorAll('[cc-element="login-button"]');
    loginButtons?.forEach((button) => {
      button.addEventListener('click', (event) => {
        FetchData.showLoginPopup();
      })
    })
  }

  initProductButtons(): void {

    this.updatePricing('monthly');
    // const ssProduct = document.querySelectorAll('.SS_ProductCheckout');
    const ssProduct: NodeListOf<HTMLAnchorElement> =
      document.querySelectorAll<HTMLAnchorElement>('a.plan-button');

    if (ssProduct) {
      ssProduct.forEach((product: HTMLAnchorElement) => {
        if (
          this.userManager.status === UserManager.AUTH_STATUS__LOGGED_OUT &&
          product.id !== 'starter'
        ) {
          product.classList.add('disabled');
          product.addEventListener('click', (event: Event) => {
            event.preventDefault();
          });
        } else {
          if (
            this.userManager.status === UserManager.AUTH_STATUS__LOGGED_OUT &&
            product.id === 'starter'
          ) {
            product.innerText = 'Upgrade';
            product.removeAttribute('cc-element');
            product.addEventListener('click', (event: Event) => {
              event.preventDefault();
              event.stopPropagation();
              FetchData.showLoginPopup();
            });
          }
        }
      });
    }
  }

  public handleRadioButtonChange(e: any) {
    console.log(
      '---------------------------- handleRadioButtonChange ------------------------------------------------'
    );
    console.log(e);
  }

  public setPlanButtons() {
    const planButtons = document.querySelectorAll('a.plan-button');
    Array.from(planButtons).forEach((button) => {
      button.addEventListener('click', function (e) {
        console.log(
          '--------------------- setPlanButtons -------------------------------------------'
        );
      });
    });
  }

  public setDurationRadio() {
    const durationRadioGroupInputs = document.querySelectorAll('input[name=duration-radio-group]');

    durationRadioGroupInputs?.forEach((inputRadioButton) => {
      inputRadioButton.parentElement?.parentElement?.addEventListener('click', function (e) {
        (inputRadioButton as HTMLInputElement).click();
      });

      inputRadioButton.addEventListener('change', (e) => {
        // FetchData.callIfLoggedIn(this.onRadioButtonCheck);
        this.onRadioButtonCheck();
      });
    });
  }

  public onRadioButtonCheck() {
    const durationRadioGroupInputs = document.querySelectorAll('input[name=duration-radio-group]');
    const durationRadioGroupInputsArray = Array.from(durationRadioGroupInputs);
    durationRadioGroupInputsArray.forEach((element: any) => {
      const elementId = element?.id;
      const currentInputRadioButton = element.parentElement?.querySelector(`.${elementId}`);

      const discountContainer = document.getElementById(`discount-${elementId}`);

      if (element.checked) {
        this.updatePricing(elementId);

        if (discountContainer) {
          discountContainer.classList.add('discount--active');
        }
        currentInputRadioButton?.classList.replace(
          'duration-radio-button-unchecked',
          'duration-radio-button-checked'
        );
      } else {
        if (discountContainer) {
          discountContainer.classList.remove('discount--active');
        }
        currentInputRadioButton?.classList.replace(
          'duration-radio-button-checked',
          'duration-radio-button-unchecked'
        );
      }
    });
  }

  private updatePricing(elementId: string) {
    if (!VISIBLE_DURATIONS.includes(elementId as any)) return;
    (VISIBLE_TIERS as readonly string[]).forEach((plan: string) => {
      // const targetPlan = plan === 'premium-plus' ? 'premium_creator' : plan;
      const targetPlan: HTMLButtonElement = document.getElementById(plan) as HTMLButtonElement;
      let price = 0;
      if (this.productPricesById && elementId in this?.productPricesById) {
        const period: SubscriptionPlan = this.productPricesById[
          elementId as keyof SubscriptionData
        ] as SubscriptionPlan;
        if (targetPlan && plan in period) {
          const uuid = (period[plan as keyof SubscriptionPlan] as Plan).uuid || '';
          targetPlan.dataset.id = uuid;
          targetPlan.dataset.productId = uuid;
          if (targetPlan.dataset.id == this?.userManager?.wallet?.subscription?.product) {
            targetPlan.disabled = true;
            targetPlan.textContent = 'Current Plan';
          } else {
            targetPlan.disabled = false;
            targetPlan.textContent = 'Upgrade';
          }

          price = (period[plan as keyof SubscriptionPlan] as Plan).price || 0;
        }
      }
      let divideBy = 1;
      let finalPrice: string = '';
      if (elementId.toLowerCase().includes('yearly')) {
        divideBy = 12;
        finalPrice = toFixedIfNecessary(price / divideBy, 2);
      } else if (elementId.toLowerCase().includes('biannually')) {
        divideBy = 6;
        finalPrice = toFixedIfNecessary(price / divideBy, 2);
      } else {
        finalPrice = price + '';
      }

      const priceElement = document.getElementById(`${plan}-price`);

      if (priceElement && price) {
        priceElement.textContent = `${finalPrice} `;
      }
    });
  }
}
